import { COLORS } from '@btime/constants'
import { props } from 'ramda'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import ControlledModal from '../../../components/modals/ControlledModal'
import Details from './Details'
import ModalHeader from './ModalHeader'
import SegmentLoader from './_load/SegmentLoader'
import Separator from '../../../components/helpers/Separator'

const ShowSegmentationModal = props => {
  return (
    <ControlledModal width="48rem" {...props}>
      <SegmentLoader>
        <ModalHeader />

        <HorizontalLine thin lineColor={COLORS.light2} />
        <Separator weight={6} />
        <Details />
      </SegmentLoader>
    </ControlledModal>
  )
}

export default ShowSegmentationModal
